module.exports = __webpack_public_path__ + "static/media/headerLogo.c2f9c831.svg";